import { render, staticRenderFns } from "./UsersProjectsTable.vue?vue&type=template&id=ceacdfb4"
import script from "./UsersProjectsTable.vue?vue&type=script&lang=js"
export * from "./UsersProjectsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports